<template>
    <tr>
        <td>{{rubric.id}}</td>
        <td>{{rubric.name}}</td>
        <td>{{rubric.image_link}}</td>
        <td>{{rubric.enabled}}</td>
        <td>
            <button
                    @click="$emit('enabled-rubric', rubric.id)"
                    type="button" class="btn btn-light btn-sm"
            >enab/disab</button>
            <button
                    @click="$emit('delete-rubric', rubric.id)"
                    type="button" class="btn btn-danger btn-sm"
            >Del</button>
            <button
                    @click="$emit('edit-rubric', rubric.id)"
                    type="button" class="btn btn-primary btn-sm"
            >Edit</button>
        </td>
    </tr>
</template>

<script>
    export default {
        props: {
            rubric: { type: Object, required: true }
        },
        emits: ['enabled-rubric', 'delete-rubric', 'edit-rubric']/*{
            "enabled-rubric": {
                type: (value) => typeof value === Number
            },
            "delete-rubric": {
                type: (value) => typeof value === Number
            },
            "edit-rubric": {
                type: (value) => typeof value === Number
            },
        }*/,
        setup() {}
    }
</script>

<style scoped>

</style>